var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.421,
    height: 56.13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.086,
    x2: 0.469,
    y1: 0.138,
    y2: 0.788,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.725 37.25h13.05l3.15-18.39h-19.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M2.025 0a2 2 0 0 0-2 2.32l8.49 51.54a2.72 2.72 0 0 0 2.66 2.27h40.73a2 2 0 0 0 2-1.68l8.49-52.12a2 2 0 0 0-2-2.32zm35.75 37.25h-13l-3.52-18.39h19.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M59.67 25.12H40.9l-3.15 18.39h-13L9.4 61.73a2.71 2.71 0 0 0 1.75.66h40.74a2 2 0 0 0 2-1.68z",
    transform: "translate(.025 -6.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.972b8ce999ec57589bc0bc5f27b8cbc3.svg";
export { ForwardRef as ReactComponent };